import { uploadFile as apiUploadFile } from '../services/api';

export const uploadFile = async (file, folder = 'images') => {
  try {
    const response = await apiUploadFile(file, folder);
    return response.data.url || response.data.imageUrl;
  } catch (error) {
    throw error;
  }
};

export const uploadImage = async (imageFile, folder = 'images') => {
  return await uploadFile(imageFile, folder);
};
